import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IStepCardProps {
  number: React.ReactText;
}

export const StepCard: React.FC<React.PropsWithChildren<IStepCardProps>> = ({ number, children }) => {
  return (
    <div className={styles['container']}>
      <span className={styles['number']}>{number}</span>
      <Body1>{children}</Body1>
    </div>
  );
};

StepCard.displayName = 'StepCard';
